import { Div, RefBool, Span, Text } from "@tblabs/truffle";
import { ExpirationTimer } from "../Utils/ExpirationTimer";
import { StepActionsBox } from "./StepActionsBox";
import { MarkedStep } from "../Models/MarkedStep";
import { AdminStepPrinterMenu } from "./AdminStepPrinterMenu";
import { StepDataEditor } from "./StepDataEditor";
import { Router } from "../Services/Router";
import { AgentsProvider } from "../Services/Agents/AgentsProvider";
import { AgentBox } from "./AgentBox";
import { TimeUtils } from "../Utils/TimeUtils";


export class AdminStepPrinter extends Div
{
    private timer = new ExpirationTimer(this.step.Step.Timeout);
    private showEdit = new RefBool(false);

    constructor(
        private _router: Router,
        private _agents: AgentsProvider,
        private step: MarkedStep)
    {
        super("step-box admin-view");

        this.Refresh();

        if (!step.Step.IsVisibleForCustomer)
            this.BorderStyle("dashed")

        if (step.Step.HoursAfterTimeout && step.Step.HoursAfterTimeout > 24 * 7)
            this.Background("lightyellow").BorderColor("darkyellow");
    }

    public async OnRemove()
    {
        this.timer?.Dispose();
    }

    private Refresh()
    {
        const step = this.step.Step;

        const agentBox = new AgentBox(this._agents, this._router, step, () => this.Refresh());

        this.Clear()
            .Append(
                new AdminStepPrinterMenu(this._router, this._agents, step, this.showEdit, () => this.Refresh()),
                new Div("step-content")
                    .Append(
                        // new Span("#" + step.Order.Id.slice(-5) + " | " + step.Data.State.value + " till " + TimeUtils.FormattedDateTime(step.Timeout)).FontSize(12).Italic().PositionAbsolute().Top(0).Left(8),
                        // new Span("#" + step.Order.ShortId + " | " + step.GetStateName() + " do " + TimeUtils.FormattedDateTime(step.Timeout)).FontSize(12).Italic().PositionAbsolute().Top(0).Left(8).Color("#ccc"),

                        new Div().TextAlignLeft().Append(
                            
                            new Span(step.GetFullTitle()).Class("step-title"),
                        ),
                        // !this._agents.IsItMe(step.Data.AssignedAgentId.value) &&
                         agentBox,
                        new Div("step-description").Append(
                            ...step.GetAdminContent(),
                        ),
                        new StepDataEditor(this.step.Step)
                            .Visible(this.showEdit)
                    ),
                new Div("step-footer").Append(
                    new StepActionsBox(step, () => this.Refresh()),
                    this.timer?.HasTimeout && new Text(this.timer.ExpiresIn).Class("step-footer-text"),
                    (!this.timer?.HasTimeout && step.WhenDone) && new Span("Zakończono " + TimeUtils.FormattedDateTime(step.WhenDone)).Class("step-footer-text"),
                ),
            )
    }
}

export class AdminStepPrinterV2 extends Div
{
    private timer = new ExpirationTimer(this.step.Step.Timeout);
    private showEdit = new RefBool(false);

    constructor(
        private _router: Router,
        private _agents: AgentsProvider,
        private step: MarkedStep)
    {
        super("step-box-v2");
        // super("");
        // this.TextAlignCenter()

        this.Refresh();

        if (!step.Step.IsVisibleForCustomer)
            this.BorderStyle("dashed")

        if (step.Step.HoursAfterTimeout && step.Step.HoursAfterTimeout > 24 * 7)
            this.Background("lightyellow").BorderColor("darkyellow");
    }

    public async OnRemove()
    {
        this.timer?.Dispose();
    }

    private StatusIcon(step: MarkedStep): string
    {
        if (step.IsDone)
            return "🟢";
        if (step.IsCurrent)
            return "🔵";

        return "⚪️";
    }

    private Refresh()
    {
        const step = this.step.Step;

        const agentBox = new AgentBox(this._agents, this._router, step, () => this.Refresh());

        const folded = new RefBool(false);

        this.Clear()
            .Append(
                // new AdminStepPrinterMenu(this._router, this._agents, step, this.showEdit, () => this.Refresh()),
                new Div("step-content vertical")
                    .Append(
                        new Span(this.StatusIcon(this.step) + " " + step.Title()).Class("step-title")
                            .OnClick(_ => folded.Toggle()),
                        // !this._agents.IsItMe(step.Data.AssignedAgentId.value) && agentBox,
                        new Div("step-description").Append(
                            ...step.GetAdminContent(),
                        )
                            .Visible(folded),
                        // new StepDataEditor(this.step.Step)
                        //     .Visible(this.showEdit)
                    ),
                new Div("step-footer").Append(
                    new StepActionsBox(
                        step, () => this.Refresh()),
                    this.timer?.HasTimeout && new Text(this.timer.ExpiresIn).Class("step-timeout"),
                ).Visible(folded),
            )
    }
}
